module.exports = __webpack_public_path__ + "static/media/viber.77ba8720.svg";